import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable';

/** V2 본문·레거시 문서 본문 모두 태그·클래스로 스타일링 */
export const PurchaseRequisitionRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& table': { ...approvalFormTableStyles(theme), minWidth: 640 },
  '& table + table': { marginTop: -1 },
  '& .pr-card + .pr-card, & #grid > div + div': { marginTop: 16 },
  '& .text-center': { textAlign: 'center' },
  '& .text-right': { textAlign: 'right' },
  '& td.label, & .bg-title, & .bg-warning': {
    textAlign: 'center',
    backgroundColor: theme.palette.grey[50],
    // 영어 라벨이 단어 중간에서 끊기지 않게
    wordBreak: 'keep-all',
  },
  '& .pr-sum td, & .bg-success': { backgroundColor: theme.palette.grey[50] },
  // 129 변경 전후 — 레거시 문서는 text-danger 라벨
  '& .pr-changed-label, & .text-danger': {
    color: theme.palette.error.main,
    fontWeight: 700,
  },
  '& td.pr-changed': {
    backgroundColor: alpha(theme.palette.success.main, 0.12),
    fontWeight: 700,
  },
  '& .textBold, & strong': { fontWeight: 700 },
  '& .pr-image img, & td[rowspan] > img': {
    display: 'block',
    maxWidth: 150,
    width: '100%',
    height: 'auto',
    margin: '0 auto',
  },
  '& .pr-card-title-row': {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minHeight: 32,
  },
  '& .pr-card-title-row > span:first-of-type': { flex: 1 },
}));
